// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"615": "home","671": "budgetDetails","929": "budgetList",}[chunkId] || chunkId) + "." + {"117": "420ebcb0d10ea533","140": "81cb26e7eab5327f","175": "cd2df8ea25411766","594": "9f2395d116982665","615": "28c112b7e1744151","671": "a2f7eb81238c580c","889": "c90f594757e9cdb4","929": "9f537439c61a9806",}[chunkId] + ".js"
}